import {
    CoreApiFilterObject,
    FILTER_TYPES,
} from '@/coreApi/filters/coreApiFilterObject'

const FILTER_ID_PAGE_FILTER = 'pf'

const coreApiPageFilters = [
    {
        title: 'Referrers',
        key: 'r',
        field_name: 'referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Home',
                value: 'site_internal_home',
            },
            {
                label: 'Internal',
                value: 'site_internal',
            },
            {
                label: 'Infinite Scroll',
                value: 'site_internal_infinite_scroll',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Hurriyet',
                value: 'hurriyet',
            },
            {
                label: 'Milliyet',
                value: 'milliyet',
            },
            {
                label: 'Sabah',
                value: 'sabah',
            },
            {
                label: 'gazeteler.com',
                value: 'gazeteler.com',
            },
            {
                label: 'gazetekeyfi.com',
                value: 'gazetekeyfi',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Sanalbasin',
                value: 'sanalbasin',
            },
            {
                label: 'f5haber.com',
                value: 'f5haber.com',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'Source Referrers',
        key: 'ord',
        field_name: 'origin_referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Hurriyet',
                value: 'hurriyet',
            },
            {
                label: 'Milliyet',
                value: 'milliyet',
            },
            {
                label: 'Sabah',
                value: 'sabah',
            },
            {
                label: 'gazeteler.com',
                value: 'gazeteler.com',
            },
            {
                label: 'gazetekeyfi.com',
                value: 'gazetekeyfi',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Sanalbasin',
                value: 'sanalbasin',
            },
            {
                label: 'f5haber.com',
                value: 'f5haber.com',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'UTM Referrers',
        key: 'ur',
        field_name: 'referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'f5haber',
            'facebook',
            'haberler.com',
            'gazetekeyfi',
            'gazeteoku',
            'google',
            'guncelhaberler',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'UTM Source Referrers',
        key: 'usr',
        field_name: 'origin_referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'f5haber',
            'facebook',
            'haberler.com',
            'gazetekeyfi',
            'gazeteoku',
            'google',
            'guncelhaberler',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'Devices',
        key: 'd',
        field_name: 'device',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Desktop',
                value: 'desktop',
            },
            {
                label: 'Mobile',
                value: 'mobile',
            },
            {
                label: 'Tablet',
                value: 'tablet',
            },
        ],
    },
    {
        title: 'Sources',
        key: 's',
        field_name: 'source',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Web',
                value: 'web',
            },
            {
                label: 'Amp',
                value: 'amp',
            },
            {
                label: 'Instance Article',
                value: 'ia',
            },
            {
                label: 'Android App',
                value: 'androidApp',
            },
            {
                label: 'IOS App',
                value: 'iosApp',
            },
        ],
    },
    {
        title: 'Domains',
        key: 'ds',
        field_name: 'page_domains',
        filter_type: 'checkbox',
        data: [
            {
                label: 'www.gazetevatan.com',
                value: 'www.gazetevatan.com',
            },
            {
                label: 'secim.gazetevatan.com',
                value: 'secim.gazetevatan.com',
            },
        ],
    },
    {
        title: 'Categories',
        key: 'c',
        field_name: 'breadcrumb_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Çalışma Hayatı', value: 'çalışma hayatı' },
            { label: 'Dünya', value: 'dünya' },
            { label: 'Eğitim', value: 'eğitim' },
            { label: 'Ekonomi', value: 'ekonomi' },
            { label: 'Gündem', value: 'gündem' },
            { label: 'Magazin', value: 'magazin' },
            { label: 'Siyaset', value: 'siyaset' },
            { label: 'Son Dakika', value: 'son dakika' },
            { label: 'Şampiy10', value: 'şampiy10' },
            { label: 'Televizyon', value: 'televizyon' },
            { label: 'Yaşam', value: 'yaşam' },
            { label: 'Yazarlar', value: 'yazarlar' },
        ],
    },
    {
        title: 'Authors',
        key: 'a',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'adonmez', value: 'adonmez' },
            { label: 'akarlidag_sil', value: 'akarlidag_sil' },
            { label: 'alican.yildirim', value: 'alican.yildirim' },
            { label: 'ayildirim', value: 'ayildirim' },
            { label: 'betulsariiz', value: 'betulsariiz' },
            { label: 'bsahin', value: 'bsahin' },
            { label: 'bsariiz', value: 'bsariiz' },
            { label: 'cakalp', value: 'cakalp' },
            { label: 'cansu.akalp', value: 'cansu.akalp' },
            { label: 'csidar', value: 'csidar' },
            { label: 'ctumdag', value: 'ctumdag' },
            { label: 'Yasemin Bradley', value: 'yasemin bradley' },
            { label: 'duygu.yesilgoz', value: 'duygu.yesilgoz' },
            { label: 'dyesilgoz', value: 'dyesilgoz' },
            { label: 'emengi', value: 'emengi' },
            { label: 'emir', value: 'emir' },
            { label: 'emre.topaloglu', value: 'emre.topaloglu' },
            { label: 'Ercan İnan', value: 'Ercan İnan' },
            { label: 'ercan.sarikaya', value: 'ercan.sarikaya' },
            { label: 'esarikaya', value: 'esarikaya' },
            { label: 'eser.kaya', value: 'eser.kaya' },
            { label: 'Filiz Özkol', value: 'filiz özkol' },
            { label: 'fseker', value: 'fseker' },
            { label: 'gkilic', value: 'gkilic' },
            { label: 'Hale Özen', value: 'hale özen' },
            { label: 'helin.genç', value: 'helin.genç' },
            { label: 'kozay', value: 'kozay' },
            { label: 'lgultekin', value: 'lgultekin' },
            { label: 'Mehmet Ali Kantarcı', value: 'mehmet ali kantarcı' },
            { label: 'Mert Nayır', value: 'mert nayır' },
            { label: 'Mutlu Tönbekici', value: 'mutlu tönbekici' },
            { label: 'nihat', value: 'nihat' },
            { label: 'nuri', value: 'nuri' },
            { label: 'oatilla', value: 'oatilla' },
            { label: 'odogu', value: 'odogu' },
            { label: 'oktay.ozturk', value: 'oktay.ozturk' },
            { label: 'oozturk', value: 'oozturk' },
            { label: 'orcun.aydinoglu', value: 'orcun.aydinoglu' },
            { label: 'ozge.dogu', value: 'ozge.dogu' },
            { label: 'sbulut', value: 'sbulut' },
            { label: 'sistem', value: 'sistem' },
            { label: 'Süleyman Ateş', value: 'süleyman ateş' },
            { label: 'suzun', value: 'suzun' },
            { label: 'turgay.yavas', value: 'turgay.yavas' },
            { label: 'yarslan', value: 'yarslan' },
            { label: 'yasin.arslan', value: 'yasin.arslan' },
            { label: 'yeliz.nergiz', value: 'yeliz.nergiz' },
        ],
    },
    {
        title: 'Editors',
        key: 'ed',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Alican Yıldırım', value: 'ayildirim' },
            { label: 'Betül Şahin Çelebi', value: 'bsahin' },
            { label: 'Betül Sarııiz', value: 'bsariiz' },
            { label: 'Burhan Şahin', value: 'bscelebi' },
            { label: 'Cansu Akalp', value: 'cakalp' },
            { label: 'Duygu Yeşilgöz', value: 'dyesilgoz' },
            { label: 'Erkan Mengi', value: 'emengi' },
            { label: 'Levent Gültekin', value: 'lgultekin' },
            { label: 'Oktay Öztürk', value: 'oatilla' },
            { label: 'Özge Doğu', value: 'odogu' },
            { label: 'Özlem Atilla', value: 'oozturk' },
            { label: 'Servet Uzun', value: 'suzun' },
            { label: 'Volkan Şahin', value: 'vsahin' },
            { label: 'Yasin Arslan', value: 'yarslan' },
        ],
    },
    {
        title: 'User Type',
        key: 'ut',
        field_name: 'user_types',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Anonymous',
                value: 'anonymous',
            },
            {
                label: 'Paid',
                value: 'paid',
            },
            {
                label: 'Logged In',
                value: 'loggedin',
            },
        ],
    },
    {
        title: 'Keywords',
        key: 'kw',
        field_name: 'keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Keywords Exclude',
        key: 'kwn',
        field_name: 'not_keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Search',
        key: 'srch',
        field_name: 'search_include',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            '404 hata sayfası',
        ],
    },
]

export const coreApiPageFilterGazetevatanObject = new CoreApiFilterObject(FILTER_ID_PAGE_FILTER, FILTER_TYPES.VALUES, coreApiPageFilters)
